import { useEffect } from "react";

/**
 * Triggers onRefresh when the user presses "r" outside of input fields.
 * Ignores the key when focus is in INPUT, TEXTAREA, SELECT, or contentEditable elements.
 */
export function useRefreshHotkey(onRefresh: () => void, disabled = false): void {
	useEffect(() => {
		const onKeyDown = (e: KeyboardEvent) => {
			if (disabled) return;
			const tag = (e.target as HTMLElement).tagName;
			if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return;
			if ((e.target as HTMLElement).isContentEditable) return;
			if (e.key === "r" && !e.ctrlKey && !e.metaKey && !e.altKey) {
				e.preventDefault();
				onRefresh();
			}
		};
		window.addEventListener("keydown", onKeyDown);
		return () => window.removeEventListener("keydown", onKeyDown);
	}, [onRefresh, disabled]);
}
